import { Notification } from 'common/notification';
import { isBeta } from 'config/constants';
import { appActions, AppContext } from 'context';
import { UserController } from 'networking/controllers/user-controller';
import { useContext, useEffect, useState } from 'react';
import { goToPage, RouteName } from 'routes';

import { Button, ButtonStyle } from 'common/button';
import { ModalTemporaryUser } from 'common/modal-record-email/modal-temporary-user';
import { trackCustomEvent } from 'helpers/analytics';
import { isTemporaryUser } from 'helpers/utils';
import { captureEvent } from 'posthog';
import { useLocation, useParams } from 'react-router-dom';
import {
  BetaMessage,
  LeftSection,
  NewVaultButton,
  RightSection,
} from './components';
import styles from './navbar.module.scss';

const OldNavbar = () => {
  const { state, dispatch } = useContext(AppContext);
  const [showError, setShowError] = useState(false);
  const [showBetaMsg, setShowBetaMsg] = useState(isBeta);
  const [showLeaveTemporaryUserModal, setShowLeaveTemporaryUserModal] =
    useState(false);
  const { guestToken } = useParams<ParamsType>();
  const { pathname } = useLocation();
  // Already creating a vault: the button would lead to the same screen.
  const onVaultCreation = pathname === '/vaults/new';

  const logOutUser = async () => {
    captureEvent('logout');
    trackCustomEvent('logOut');
    try {
      await UserController.signOutUser();
      dispatch({ type: appActions.SESSION_EXPIRED });
      goToPage(RouteName.SignIn);
    } catch (e) {
      setShowError(true);
    }
  };

  const authenticate = async () => {
    if (state.logged) {
      return;
    }

    try {
      const data = await UserController.me();
      dispatch({ type: appActions.USER_LOGGED, data });
    } catch (e) {
      dispatch({ type: appActions.SESSION_EXPIRED });
    }
  };

  useEffect(() => {
    authenticate();
  }, []);
  useEffect(() => {
    dispatch({ type: appActions.BETA_MSG, showBetaMsg });
  }, [showBetaMsg]);
  useEffect(() => {
    if (guestToken) {
      UserController.addGuestTokenHeader(guestToken);
      return UserController.removeGuestTokenHeader;
    }
    return undefined;
  }, [guestToken]);

  const showErrorNotification = () => (
    <Notification
      message="We couldn’t log you out. Please try again."
      handleClose={() => setShowError(false)}
    />
  );

  const showNavbarToTemporaryUsers = (user: UserType) => (
    <nav id="navbar-fixed" className={styles.container}>
      {showBetaMsg && <BetaMessage onClose={() => setShowBetaMsg(false)} />}
      <div className={styles.navbar}>
        <LeftSection user={user} />
        <div className={styles.buttonBox}>
          <Button
            buttonStyle={ButtonStyle.GreyGhost}
            onClick={() => setShowLeaveTemporaryUserModal(true)}
          >
            Leave trial
          </Button>
          <Button
            onClick={() => goToPage(RouteName.SignUp)}
            buttonStyle={ButtonStyle.PrimaryGhost}
          >
            Sign up
          </Button>
        </div>
      </div>
    </nav>
  );

  const showNavbar = (user: UserType, currentVault?: VaultType) => (
    <nav id="navbar-fixed" className={styles.container}>
      {showBetaMsg && <BetaMessage onClose={() => setShowBetaMsg(false)} />}
      <div className={styles.navbar} id="nav-bar">
        {' '}
        {/* The div had ref={navBarRef} */}
        <LeftSection user={user} currentVault={currentVault} />
        <div className={styles.rightArea}>
          {state.logged && !isTemporaryUser(user) && !onVaultCreation && (
            <NewVaultButton />
          )}
          <RightSection user={user} logOutUser={logOutUser} />
        </div>
      </div>
    </nav>
  );

  return (
    <>
      {showError && showErrorNotification()}
      {showLeaveTemporaryUserModal && (
        <ModalTemporaryUser
          onClose={() => setShowLeaveTemporaryUserModal(false)}
        />
      )}
      {isTemporaryUser(state.data.user)
        ? showNavbarToTemporaryUsers(state.data.user)
        : showNavbar(state.data.user, state.currentVault)}
    </>
  );
};

export { OldNavbar };
